/**
 * Use the DataStore to avoid making multiple requests to the same endpoints across different LCP components.
 */
export default class DataStore {
  constructor(boundaryId, status = 'Active,ActiveUnderContract') {
    this.boundaryId = boundaryId
    this.status = status.split(',').map((s) => s.trim()).join(',')
    this.mls = null
    this.minimumHomePrice =  15000
    this.types = null
    this.subTypes = null
    this.data = {}
    this.queue = {}
  }
  setTypes = (types) => {
    this.types = types.map((s) => s.trim()).join(',')
  }

  setSubTypes = (subTypes) => {
    this.subTypes = subTypes.map((s) => s.trim()).join(',')
  }

  setMinimumHomePrice = (minPrice) => {
    this.minimumHomePrice = minPrice
  }

  setMls = (mls) => {
    this.mls = mls.map((s) => s.trim()).join(',')
  }

  get(type, onComplete) {
    // if data has already been loaded, return the loaded data (the point of this data store)
    if (this.data[type]) {
      return onComplete(this.data[type])
    }

    // if queue does not exist, create it and push the current onComplete function into it so we can process it when finished
    if (!this.queue[type]) {
      this.queue[type] = []
    }

    this.queue[type].push(onComplete)

    // if only one item is in the queue, this is the first time we're getting this data so go ahead and GET it otherwise will be processed via the queue when finished
    if (this.queue[type].length === 1) {
      switch (type) {
        case 'census':
          setTimeout(() => {
            fetch(
              `https://${
                process.env.REACT_APP_API_ENDPOINT || 'api.liveby.com'
              }/v1/pages/census?boundaryId=${encodeURIComponent(
                this.boundaryId
              )}`
            )
              .then((res) => res.json())
              .then((data) => {
                this.done(type, data)
              })
              .catch((err) => {
                this.data[type] = false
                console.error('Failed to get census data.')
                console.error(err)
              })
          }, 0)
          break
        case 'activeStats':
          const opts = {
            boundaryId: this.boundaryId,
            status: this.status,
            mls: this.mls,
            minPrice: this.minimumHomePrice,
            types: this.types,
            subTypes: this.subTypes
          }
          let filteredOpts = Object.fromEntries(Object.entries(opts).filter(([_, v]) => v != null));
            
          setTimeout(async () => {
            fetch(
                `https://${
                  process.env.REACT_APP_API_ENDPOINT || 'api.liveby.com'
                }/v1/market-stats/actives`,{ 
                  method: 'POST', 
                  mode: 'cors',
                  body: JSON.stringify(filteredOpts) }
              )
              .then((res) => res.json())
              .then((data) => {
                this.done(type, data)
              })
              .catch((err) => {
                this.data[type] = false
                console.error('Failed to get census data.')
                console.error(err)
              })
          }, 0)
          break
        default:
          console.error(`DataStore does not support data type: ${type}`)
          break
      }
    }
  }

  // process the queue and delete it after the data property has been updated with the data from the response and handlers have been executed
  done(type, data) {
    this.data[type] = data
    this.queue[type].forEach((onCompleteHandler) => {
      onCompleteHandler(data)
    })
    delete this.queue[type]
  }
}
